module.exports={
  "SilverDecisions": "1.1.0",
  "buildTimestamp": 1669186055643,
  "savetime": "2024-03-02T14:10:54.488Z",
  "lng": "en",
  "viewMode": "criterion1",
  "rule": "expected-value-maximization",
  "title": "",
  "description": "",
  "format": {
    "locales": "en",
    "payoff1": {
      "style": "currency",
      "currency": "USD",
      "currencyDisplay": "symbol",
      "minimumFractionDigits": 0,
      "maximumFractionDigits": 0,
      "useGrouping": true
    },
    "payoff2": {
      "style": "percent",
      "currency": "USD",
      "currencyDisplay": "symbol",
      "minimumFractionDigits": 0,
      "maximumFractionDigits": 0,
      "useGrouping": true
    },
    "probability": {
      "style": "percent",
      "minimumFractionDigits": 0,
      "maximumFractionDigits": 0,
      "useGrouping": true
    }
  },
  "treeDesigner": {
    "margin": {
      "left": 550,
      "right": 500,
      "top": 200,
      "bottom": 100
    },
    "scale": 1,
    "lng": "en",
    "layout": {
      "type": "tree",
      "nodeSize": 22,
      "limitNodePositioning": true,
      "limitTextPositioning": false,
      "gridHeight": 102,
      "gridWidth": 260,
      "edgeSlantWidthMax": 0
    },
    "fontFamily": "sans-serif",
    "fontSize": "12px",
    "fontWeight": "normal",
    "fontStyle": "normal",
    "node": {
      "strokeWidth": "2px",
      "optimal": {
        "stroke": "#006f00",
        "strokeWidth": "2px"
      },
      "label": {
        "fontSize": "1em",
        "color": "black"
      },
      "payoff": {
        "fontSize": "1em",
        "color": "black",
        "negativeColor": "#b60000"
      },
      "decision": {
        "fill": "#ff7777",
        "stroke": "#660000",
        "selected": {
          "fill": "#aa3333"
        }
      },
      "chance": {
        "fill": "#ffff44",
        "stroke": "#666600",
        "selected": {
          "fill": "#aaaa00"
        }
      },
      "terminal": {
        "fill": "#44ff44",
        "stroke": "black",
        "selected": {
          "fill": "#00aa00"
        },
        "payoff": {
          "fontSize": "1em",
          "color": "black",
          "negativeColor": "#b60000"
        }
      }
    },
    "edge": {
      "stroke": "#424242",
      "strokeWidth": "1.5",
      "optimal": {
        "stroke": "#006f00",
        "strokeWidth": "2.4"
      },
      "selected": {
        "stroke": "#045ad1",
        "strokeWidth": "3.5"
      },
      "label": {
        "fontSize": "1em",
        "color": "back"
      },
      "payoff": {
        "fontSize": "1em",
        "color": "black",
        "negativeColor": "#b60000"
      }
    },
    "probability": {
      "fontSize": "1em",
      "color": "#0000d7"
    },
    "title": {
      "fontSize": "16px",
      "fontWeight": "bold",
      "fontStyle": "normal",
      "color": "#000000",
      "margin": {
        "top": 15,
        "bottom": 10
      }
    },
    "description": {
      "show": true,
      "fontSize": "12px",
      "fontWeight": "bold",
      "fontStyle": "normal",
      "color": "#000000",
      "margin": {
        "top": 5,
        "bottom": 10
      }
    },
    "readOnly": false,
    "disableAnimations": false,
    "forceFullEdgeRedraw": false,
    "hideLabels": false,
    "hidePayoffs": false,
    "hideProbabilities": false,
    "hideCharts": false,
    "hideTextboxes": false,
    "hideMilestones": false,
    "raw": false,
    "payoffNames": [
      null,
      null
    ],
    "maxPayoffsToDisplay": 1,
    "milestoneNames": [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    ]
  },
  "data": {
    "code": "",
    "expressionScope": {},
    "trees": [
      {
        "computed": {
          "expected-value-maximization": {
            "childrenPayoff": [
              "70"
            ],
            "payoff": [
              "70"
            ],
            "optimal": true
          },
          "expected-value-minimization": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "maxi-min": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "maxi-max": {
            "childrenPayoff": [
              "100"
            ],
            "payoff": [
              "100"
            ],
            "optimal": true
          },
          "mini-min": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "mini-max": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "min-max": {
            "childrenPayoff": [
              "0",
              "0"
            ],
            "combinedPayoff": "0",
            "payoff": [
              "0",
              "0"
            ],
            "optimal": true
          },
          "max-min": {
            "childrenPayoff": [
              "70",
              "0"
            ],
            "combinedPayoff": "70",
            "payoff": [
              "70",
              "0"
            ],
            "optimal": true
          },
          "min-min": {
            "childrenPayoff": [
              "0",
              "0"
            ],
            "combinedPayoff": "0",
            "payoff": [
              "0",
              "0"
            ],
            "optimal": true
          },
          "max-max": {
            "childrenPayoff": [
              "70",
              "0"
            ],
            "combinedPayoff": "70",
            "payoff": [
              "70",
              "0"
            ],
            "optimal": true
          }
        },
        "childEdges": [
          {
            "computed": {
              "payoff": [
                "0",
                "0"
              ],
              "expected-value-maximization": {
                "probability": 1,
                "optimal": true
              },
              "expected-value-minimization": {
                "probability": 1,
                "optimal": true
              },
              "maxi-min": {
                "probability": 1,
                "optimal": true
              },
              "maxi-max": {
                "probability": 1,
                "optimal": true
              },
              "mini-min": {
                "probability": 1,
                "optimal": true
              },
              "mini-max": {
                "probability": 1,
                "optimal": true
              },
              "min-max": {
                "probability": 1,
                "optimal": true
              },
              "max-min": {
                "probability": 1,
                "optimal": true
              },
              "min-min": {
                "probability": 1,
                "optimal": true
              },
              "max-max": {
                "probability": 1,
                "optimal": true
              }
            },
            "name": "Alternative A",
            "payoff": [
              0,
              0
            ],
            "childNode": {
              "computed": {
                "expected-value-maximization": {
                  "childrenPayoff": [
                    "70"
                  ],
                  "payoff": [
                    "70"
                  ],
                  "optimal": true
                },
                "expected-value-minimization": {
                  "childrenPayoff": [
                    "0"
                  ],
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "maxi-min": {
                  "childrenPayoff": [
                    "0"
                  ],
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "maxi-max": {
                  "childrenPayoff": [
                    "100"
                  ],
                  "payoff": [
                    "100"
                  ],
                  "optimal": true
                },
                "mini-min": {
                  "childrenPayoff": [
                    "0"
                  ],
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "mini-max": {
                  "childrenPayoff": [
                    "0"
                  ],
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "min-max": {
                  "childrenPayoff": [
                    "0",
                    "0"
                  ],
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ],
                  "optimal": true
                },
                "max-min": {
                  "childrenPayoff": [
                    "70",
                    "0"
                  ],
                  "combinedPayoff": "70",
                  "payoff": [
                    "70",
                    "0"
                  ],
                  "optimal": true
                },
                "min-min": {
                  "childrenPayoff": [
                    "0",
                    "0"
                  ],
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ],
                  "optimal": true
                },
                "max-max": {
                  "childrenPayoff": [
                    "70",
                    "0"
                  ],
                  "combinedPayoff": "70",
                  "payoff": [
                    "70",
                    "0"
                  ],
                  "optimal": true
                }
              },
              "childEdges": [
                {
                  "computed": {
                    "payoff": [
                      "0",
                      "0"
                    ],
                    "probability": "7/10",
                    "expected-value-maximization": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "expected-value-minimization": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "maxi-min": {
                      "probability": 0,
                      "optimal": false
                    },
                    "maxi-max": {
                      "probability": 1,
                      "optimal": true
                    },
                    "mini-min": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "mini-max": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "min-max": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "max-min": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "min-min": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "max-max": {
                      "probability": "7/10",
                      "optimal": true
                    }
                  },
                  "name": "Outcome A",
                  "probability": ".7",
                  "payoff": [
                    0,
                    0
                  ],
                  "childNode": {
                    "computed": {
                      "expected-value-maximization": {
                        "childrenPayoff": [
                          "100"
                        ],
                        "payoff": [
                          "100"
                        ],
                        "optimal": true
                      },
                      "expected-value-minimization": {
                        "childrenPayoff": [
                          "0"
                        ],
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "maxi-min": {
                        "childrenPayoff": [
                          "100"
                        ],
                        "payoff": [
                          "100"
                        ]
                      },
                      "maxi-max": {
                        "childrenPayoff": [
                          "100"
                        ],
                        "payoff": [
                          "100"
                        ],
                        "optimal": true
                      },
                      "mini-min": {
                        "childrenPayoff": [
                          "0"
                        ],
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "mini-max": {
                        "childrenPayoff": [
                          "0"
                        ],
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "min-max": {
                        "childrenPayoff": [
                          "0",
                          "0"
                        ],
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-min": {
                        "childrenPayoff": [
                          "100",
                          "0"
                        ],
                        "combinedPayoff": "100",
                        "payoff": [
                          "100",
                          "0"
                        ],
                        "optimal": true
                      },
                      "min-min": {
                        "childrenPayoff": [
                          "0",
                          "0"
                        ],
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-max": {
                        "childrenPayoff": [
                          "100",
                          "0"
                        ],
                        "combinedPayoff": "100",
                        "payoff": [
                          "100",
                          "0"
                        ],
                        "optimal": true
                      }
                    },
                    "childEdges": [
                      {
                        "computed": {
                          "payoff": [
                            "100",
                            "0"
                          ],
                          "expected-value-maximization": {
                            "probability": 1,
                            "optimal": true
                          },
                          "expected-value-minimization": {
                            "probability": 0,
                            "optimal": false
                          },
                          "maxi-min": {
                            "probability": 1
                          },
                          "maxi-max": {
                            "probability": 1,
                            "optimal": true
                          },
                          "mini-min": {
                            "probability": 0,
                            "optimal": false
                          },
                          "mini-max": {
                            "probability": 0,
                            "optimal": false
                          },
                          "min-max": {
                            "probability": 0,
                            "optimal": false
                          },
                          "max-min": {
                            "probability": 1,
                            "optimal": true
                          },
                          "min-min": {
                            "probability": 0,
                            "optimal": false
                          },
                          "max-max": {
                            "probability": 1,
                            "optimal": true
                          }
                        },
                        "name": "Alternative X",
                        "payoff": [
                          "100",
                          0
                        ],
                        "childNode": {
                          "computed": {
                            "expected-value-maximization": {
                              "aggregatedPayoff": [
                                "100"
                              ],
                              "probabilityToEnter": "7/10",
                              "payoff": [
                                "100"
                              ],
                              "optimal": true
                            },
                            "expected-value-minimization": {
                              "aggregatedPayoff": [
                                "100"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "100"
                              ]
                            },
                            "maxi-min": {
                              "aggregatedPayoff": [
                                "100"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "100"
                              ]
                            },
                            "maxi-max": {
                              "aggregatedPayoff": [
                                "100"
                              ],
                              "probabilityToEnter": "1",
                              "payoff": [
                                "100"
                              ],
                              "optimal": true
                            },
                            "mini-min": {
                              "aggregatedPayoff": [
                                "100"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "100"
                              ]
                            },
                            "mini-max": {
                              "aggregatedPayoff": [
                                "100"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "100"
                              ]
                            },
                            "min-max": {
                              "aggregatedPayoff": [
                                "100",
                                "0"
                              ],
                              "probabilityToEnter": 0,
                              "combinedPayoff": "-100",
                              "payoff": [
                                "100",
                                "0"
                              ]
                            },
                            "max-min": {
                              "aggregatedPayoff": [
                                "100",
                                "0"
                              ],
                              "probabilityToEnter": "7/10",
                              "combinedPayoff": "100",
                              "payoff": [
                                "100",
                                "0"
                              ],
                              "optimal": true
                            },
                            "min-min": {
                              "aggregatedPayoff": [
                                "100",
                                "0"
                              ],
                              "probabilityToEnter": 0,
                              "combinedPayoff": "-100",
                              "payoff": [
                                "100",
                                "0"
                              ]
                            },
                            "max-max": {
                              "aggregatedPayoff": [
                                "100",
                                "0"
                              ],
                              "probabilityToEnter": "7/10",
                              "combinedPayoff": "100",
                              "payoff": [
                                "100",
                                "0"
                              ],
                              "optimal": true
                            }
                          },
                          "childEdges": [],
                          "name": "Payoff",
                          "code": "",
                          "expressionScope": {},
                          "folded": false,
                          "location": {
                            "x": 791,
                            "y": 11
                          },
                          "type": "terminal",
                          "expectedValue": 100,
                          "p10": 100,
                          "p90": 100
                        },
                        "expectedValue": 100,
                        "p10": 100,
                        "p90": 100,
                        "optimal": true
                      },
                      {
                        "computed": {
                          "payoff": [
                            "0",
                            "0"
                          ],
                          "expected-value-maximization": {
                            "probability": 0,
                            "optimal": false
                          },
                          "expected-value-minimization": {
                            "probability": 1,
                            "optimal": true
                          },
                          "maxi-min": {
                            "probability": 0
                          },
                          "maxi-max": {
                            "probability": 0,
                            "optimal": false
                          },
                          "mini-min": {
                            "probability": 1,
                            "optimal": true
                          },
                          "mini-max": {
                            "probability": 1,
                            "optimal": true
                          },
                          "min-max": {
                            "probability": 1,
                            "optimal": true
                          },
                          "max-min": {
                            "probability": 0,
                            "optimal": false
                          },
                          "min-min": {
                            "probability": 1,
                            "optimal": true
                          },
                          "max-max": {
                            "probability": 0,
                            "optimal": false
                          }
                        },
                        "name": "Alternative Y",
                        "payoff": [
                          0,
                          0
                        ],
                        "childNode": {
                          "computed": {
                            "expected-value-maximization": {
                              "aggregatedPayoff": [
                                "0"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "0"
                              ]
                            },
                            "expected-value-minimization": {
                              "aggregatedPayoff": [
                                "0"
                              ],
                              "probabilityToEnter": "7/10",
                              "payoff": [
                                "0"
                              ],
                              "optimal": true
                            },
                            "maxi-min": {
                              "aggregatedPayoff": [
                                "0"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "0"
                              ]
                            },
                            "maxi-max": {
                              "aggregatedPayoff": [
                                "0"
                              ],
                              "probabilityToEnter": 0,
                              "payoff": [
                                "0"
                              ]
                            },
                            "mini-min": {
                              "aggregatedPayoff": [
                                "0"
                              ],
                              "probabilityToEnter": "1/2",
                              "payoff": [
                                "0"
                              ],
                              "optimal": true
                            },
                            "mini-max": {
                              "aggregatedPayoff": [
                                "0"
                              ],
                              "probabilityToEnter": "1/2",
                              "payoff": [
                                "0"
                              ],
                              "optimal": true
                            },
                            "min-max": {
                              "aggregatedPayoff": [
                                "0",
                                "0"
                              ],
                              "probabilityToEnter": "7/10",
                              "combinedPayoff": "0",
                              "payoff": [
                                "0",
                                "0"
                              ],
                              "optimal": true
                            },
                            "max-min": {
                              "aggregatedPayoff": [
                                "0",
                                "0"
                              ],
                              "probabilityToEnter": 0,
                              "combinedPayoff": "0",
                              "payoff": [
                                "0",
                                "0"
                              ]
                            },
                            "min-min": {
                              "aggregatedPayoff": [
                                "0",
                                "0"
                              ],
                              "probabilityToEnter": "7/10",
                              "combinedPayoff": "0",
                              "payoff": [
                                "0",
                                "0"
                              ],
                              "optimal": true
                            },
                            "max-max": {
                              "aggregatedPayoff": [
                                "0",
                                "0"
                              ],
                              "probabilityToEnter": 0,
                              "combinedPayoff": "0",
                              "payoff": [
                                "0",
                                "0"
                              ]
                            }
                          },
                          "childEdges": [],
                          "name": "Payoff",
                          "code": "",
                          "expressionScope": {},
                          "folded": false,
                          "location": {
                            "x": 791,
                            "y": 113.00000000000001
                          },
                          "type": "terminal",
                          "expectedValue": 0,
                          "p10": 0,
                          "p90": 0
                        },
                        "expectedValue": 0,
                        "p10": 0,
                        "p90": 0,
                        "optimal": false
                      }
                    ],
                    "name": "Decision",
                    "code": "",
                    "expressionScope": {},
                    "folded": false,
                    "location": {
                      "x": 531,
                      "y": 62
                    },
                    "type": "decision",
                    "expectedValue": 100,
                    "p10": 100,
                    "p90": 100
                  },
                  "expectedValue": 0,
                  "p10": 0,
                  "p90": 0,
                  "optimal": true
                },
                {
                  "computed": {
                    "payoff": [
                      "0",
                      "0"
                    ],
                    "probability": "3/10",
                    "expected-value-maximization": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "expected-value-minimization": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "maxi-min": {
                      "probability": 1,
                      "optimal": true
                    },
                    "maxi-max": {
                      "probability": 0,
                      "optimal": false
                    },
                    "mini-min": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "mini-max": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "min-max": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "max-min": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "min-min": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "max-max": {
                      "probability": "3/10",
                      "optimal": true
                    }
                  },
                  "name": "Outcome B",
                  "probability": "#",
                  "payoff": [
                    0,
                    0
                  ],
                  "childNode": {
                    "computed": {
                      "expected-value-maximization": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "expected-value-minimization": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "maxi-min": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "maxi-max": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "0"
                        ]
                      },
                      "mini-min": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "mini-max": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "min-max": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-min": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ],
                        "optimal": true
                      },
                      "min-min": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-max": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ],
                        "optimal": true
                      }
                    },
                    "childEdges": [],
                    "name": "Payoff",
                    "code": "",
                    "expressionScope": {},
                    "folded": false,
                    "location": {
                      "x": 531,
                      "y": 164
                    },
                    "type": "terminal",
                    "expectedValue": 0,
                    "p10": 0,
                    "p90": 0
                  },
                  "expectedValue": 0,
                  "p10": 0,
                  "p90": 0,
                  "optimal": true
                }
              ],
              "name": "Chance",
              "code": "",
              "expressionScope": {},
              "folded": false,
              "location": {
                "x": 271,
                "y": 113.00000000000001
              },
              "type": "chance",
              "expectedValue": 70,
              "p10": 0,
              "p90": 100
            },
            "expectedValue": 0,
            "p10": 0,
            "p90": 0,
            "optimal": true
          },
          {
            "computed": {
              "payoff": [
                "0",
                "0"
              ],
              "expected-value-maximization": {
                "probability": 0,
                "optimal": false
              },
              "expected-value-minimization": {
                "probability": 1,
                "optimal": true
              },
              "maxi-min": {
                "probability": 1,
                "optimal": true
              },
              "maxi-max": {
                "probability": 0,
                "optimal": false
              },
              "mini-min": {
                "probability": 1,
                "optimal": true
              },
              "mini-max": {
                "probability": 1,
                "optimal": true
              },
              "min-max": {
                "probability": 1,
                "optimal": true
              },
              "max-min": {
                "probability": 0,
                "optimal": false
              },
              "min-min": {
                "probability": 1,
                "optimal": true
              },
              "max-max": {
                "probability": 0,
                "optimal": false
              }
            },
            "name": "Alternative B",
            "payoff": [
              0,
              0
            ],
            "childNode": {
              "computed": {
                "expected-value-maximization": {
                  "childrenPayoff": [
                    "0"
                  ],
                  "payoff": [
                    "0"
                  ]
                },
                "expected-value-minimization": {
                  "childrenPayoff": [
                    "0"
                  ],
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "maxi-min": {
                  "childrenPayoff": [
                    "0"
                  ],
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "maxi-max": {
                  "childrenPayoff": [
                    "0"
                  ],
                  "payoff": [
                    "0"
                  ]
                },
                "mini-min": {
                  "childrenPayoff": [
                    "0"
                  ],
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "mini-max": {
                  "childrenPayoff": [
                    "0"
                  ],
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "min-max": {
                  "childrenPayoff": [
                    "0",
                    "0"
                  ],
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ],
                  "optimal": true
                },
                "max-min": {
                  "childrenPayoff": [
                    "0",
                    "0"
                  ],
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ]
                },
                "min-min": {
                  "childrenPayoff": [
                    "0",
                    "0"
                  ],
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ],
                  "optimal": true
                },
                "max-max": {
                  "childrenPayoff": [
                    "0",
                    "0"
                  ],
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ]
                }
              },
              "childEdges": [
                {
                  "computed": {
                    "payoff": [
                      "0",
                      "0"
                    ],
                    "probability": "1/2",
                    "expected-value-maximization": {
                      "probability": "1/2"
                    },
                    "expected-value-minimization": {
                      "probability": "1/2",
                      "optimal": true
                    },
                    "maxi-min": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "maxi-max": {
                      "probability": 0.5
                    },
                    "mini-min": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "mini-max": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "min-max": {
                      "probability": "1/2",
                      "optimal": true
                    },
                    "max-min": {
                      "probability": "1/2"
                    },
                    "min-min": {
                      "probability": "1/2",
                      "optimal": true
                    },
                    "max-max": {
                      "probability": "1/2"
                    }
                  },
                  "name": "",
                  "probability": "#",
                  "payoff": [
                    0,
                    0
                  ],
                  "childNode": {
                    "computed": {
                      "expected-value-maximization": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "0"
                        ]
                      },
                      "expected-value-minimization": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "maxi-min": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "maxi-max": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "0"
                        ]
                      },
                      "mini-min": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "mini-max": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "min-max": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-min": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ]
                      },
                      "min-min": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-max": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ]
                      }
                    },
                    "childEdges": [],
                    "name": "Payoff",
                    "code": "",
                    "expressionScope": {},
                    "folded": false,
                    "location": {
                      "x": 531,
                      "y": 286.40000000000003
                    },
                    "type": "terminal",
                    "expectedValue": 0,
                    "p10": 0,
                    "p90": 0
                  },
                  "expectedValue": 0,
                  "p10": 0,
                  "p90": 0,
                  "optimal": false
                },
                {
                  "computed": {
                    "payoff": [
                      "0",
                      "0"
                    ],
                    "probability": "1/2",
                    "expected-value-maximization": {
                      "probability": "1/2"
                    },
                    "expected-value-minimization": {
                      "probability": "1/2",
                      "optimal": true
                    },
                    "maxi-min": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "maxi-max": {
                      "probability": 0.5
                    },
                    "mini-min": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "mini-max": {
                      "probability": 0.5,
                      "optimal": true
                    },
                    "min-max": {
                      "probability": "1/2",
                      "optimal": true
                    },
                    "max-min": {
                      "probability": "1/2"
                    },
                    "min-min": {
                      "probability": "1/2",
                      "optimal": true
                    },
                    "max-max": {
                      "probability": "1/2"
                    }
                  },
                  "name": "",
                  "probability": "#",
                  "payoff": [
                    0,
                    0
                  ],
                  "childNode": {
                    "computed": {
                      "expected-value-maximization": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "0"
                        ]
                      },
                      "expected-value-minimization": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "maxi-min": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "maxi-max": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "0"
                        ]
                      },
                      "mini-min": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "mini-max": {
                        "aggregatedPayoff": [
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "payoff": [
                          "0"
                        ],
                        "optimal": true
                      },
                      "min-max": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-min": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ]
                      },
                      "min-min": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": "1/2",
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-max": {
                        "aggregatedPayoff": [
                          "0",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "0",
                        "payoff": [
                          "0",
                          "0"
                        ]
                      }
                    },
                    "childEdges": [],
                    "name": "Payoff",
                    "code": "",
                    "expressionScope": {},
                    "folded": false,
                    "location": {
                      "x": 531,
                      "y": 388.40000000000003
                    },
                    "type": "terminal",
                    "expectedValue": 0,
                    "p10": 0,
                    "p90": 0
                  },
                  "expectedValue": 0,
                  "p10": 0,
                  "p90": 0,
                  "optimal": false
                }
              ],
              "name": "Chance",
              "code": "",
              "expressionScope": {},
              "folded": false,
              "location": {
                "x": 271,
                "y": 337.40000000000003
              },
              "type": "chance",
              "expectedValue": 0,
              "p10": 0,
              "p90": 0
            },
            "expectedValue": 0,
            "p10": 0,
            "p90": 0,
            "optimal": false
          }
        ],
        "name": "Decision",
        "code": "",
        "expressionScope": {},
        "folded": false,
        "location": {
          "x": 11,
          "y": 225.20000000000002
        },
        "type": "decision",
        "expectedValue": 70,
        "p10": 0,
        "p90": 100
      }
    ],
    "texts": [],
    "payoffNames": [],
    "defaultCriterion1Weight": 1,
    "weightLowerBound": 0,
    "weightUpperBound": "Infinity"
  },
  "sensitivityAnalysis": {},
  "definitionsDialog": {
    "valueList": [
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      }
    ]
  }
}